import { QueryClient } from "@tanstack/react-query";

/** Server state: short staleness, no retry on problem documents (they are answers, not failures). */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 10_000,
      retry: (count, error) =>
        !(error instanceof Error && error.name === "ProblemError") && count < 2,
    },
  },
});
